webpackJsonp([8568786762062731000],{

/***/ "../node_modules/drip-form-validator/lib/locale/ja.js":
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var format = __webpack_require__("../node_modules/date-fns/format/index.js");
	var Validator_1 = __webpack_require__("../node_modules/drip-form-validator/lib/Validator.js");
	var dateToString = function (date) { return format(date, 'YYYY-MM-DD HH:mm:ss'); };
	Validator_1.default.defineLocale('ja', {
	    defaultMessage: '{{field}}が正しくありません。',
	    after: function (field, _, params) { return (field + "\u306F" + dateToString(params.date) + "\u3088\u308A\u5F8C\u306E\u65E5\u4ED8\u3092\u6307\u5B9A\u3057\u3066\u304F\u3060\u3055\u3044\u3002."); },
	    alpha: '{{field}}にはアルファベットのみご利用できます。',
	    alphaDash: '{{field}}にはアルファベットとダッシュ(-)及び下線(_)がご利用できます。',
	    alphaNumeric: '{{field}}には英数字がご利用できます。',
	    array: '{{field}}は配列でなくてはなりません。',
	    before: function (field, _, params) { return (field + "\u306F" + dateToString(params.date) + "\u3088\u308A\u524D\u306E\u65E5\u4ED8\u3092\u6307\u5B9A\u3057\u3066\u304F\u3060\u3055\u3044\u3002."); },
	    between: {
	        defaultMessage: '{{field}}は{{min}}から{{max}}の間で指定してください。',
	        string: '{{field}}は{{min}}から{{max}}文字の間で指定してください。',
	        array: '{{field}}は{{min}}から{{max}}個の間で指定してください。',
	    },
	    betweenWith: '{{field}}は{{min}}から{{max}}の間で指定してください。',
	    date: '{{field}}には有効な日付を指定してください。',
	    dateFormat: '{{field}}には有効な日付を指定してください。',
	    different: '{{field}}は{{label}}には異なる内容を指定してください。',
	    email: '{{field}}には有効なメールアドレスを指定してください。',
	    equals: '{{field}}は"{{value}}"でなくてはなりません。',
	    falsy: '{{field}}は無効な内容でなくてはなりません。',
	    float: '{{field}}は少数を含む数値でなくてはなりません。',
	    format: '{{field}}の形式が正しくありません。',
	    in: '{{field}}が正しくありません。',
	    integer: '{{field}}は整数でなくてはなりません。',
	    lowercase: '{{field}}は小文字でなくてはなりません。',
	    max: {
	        defaultMessage: '{{field}}は{{max}}以下を指定してください。',
	        string: '{{field}}は{{max}}文字以下で指定してください。',
	        array: '{{field}}は{{max}}個以下で指定してください。',
	    },
	    maxWith: '{{field}}は{{max}}以下の数値を指定してください。',
	    min: {
	        defaultMessage: '{{field}}は{{min}}以上を指定してください。',
	        string: '{{field}}は{{min}}文字以上で指定してください。',
	        array: '{{field}}は{{min}}個以上で指定してください。',
	    },
	    minWith: '{{field}}は{{min}}以上を指定してください。',
	    natural: '{{field}}は自然数でなくてはなりません。',
	    notIn: '{{field}}が正しくありません。',
	    number: '{{field}}は数値でなくてはなりません。',
	    numeric: '{{field}}は数値でなくてはなりません。',
	    object: '{{field}}はオブジェクトでなくてはなりません。',
	    present: '{{field}}が存在する必要があります。',
	    required: '{{field}}は必須項目です。',
	    same: '{{field}}と{{label}}は一致しなくてはなりません。',
	    size: {
	        defaultMessage: '{{field}}は{{size}}を指定してください。',
	        string: '{{field}}は{{size}}文字で指定してください。',
	        array: '{{field}}は{{size}}個で指定してください。',
	    },
	    string: '{{field}}は文字列を指定してください。',
	    time: '{{field}}は有効な時間を指定してください。',
	    truthy: '{{field}}は有効な内容を指定してください。',
	    uppercase: '{{field}}は大文字でなくてはなりません。',
	    url: '{{field}}の形式が正しくありません。',
	});


/***/ }),

/***/ "./node_modules/babel-loader/lib/index.js?{\"presets\":[\"/Users/tsuyoshiwada/develop/react-drip-form/www/node_modules/babel-preset-es2015/lib/index.js\",\"/Users/tsuyoshiwada/develop/react-drip-form/www/node_modules/babel-preset-stage-1/lib/index.js\",\"/Users/tsuyoshiwada/develop/react-drip-form/www/node_modules/babel-preset-react/lib/index.js\",\"/Users/tsuyoshiwada/develop/react-drip-form/www/node_modules/babel-preset-env/lib/index.js\",\"/Users/tsuyoshiwada/develop/react-drip-form/www/node_modules/babel-preset-stage-0/lib/index.js\",\"/Users/tsuyoshiwada/develop/react-drip-form/www/node_modules/babel-preset-react/lib/index.js\"],\"plugins\":[\"/Users/tsuyoshiwada/develop/react-drip-form/www/node_modules/gatsby/dist/utils/babel-plugin-extract-graphql.js\",\"/Users/tsuyoshiwada/develop/react-drip-form/www/node_modules/babel-plugin-add-module-exports/lib/index.js\",\"/Users/tsuyoshiwada/develop/react-drip-form/www/node_modules/babel-plugin-add-module-exports/lib/index.js\",\"/Users/tsuyoshiwada/develop/react-drip-form/www/node_modules/babel-plugin-add-module-exports/lib/index.js\",\"/Users/tsuyoshiwada/develop/react-drip-form/www/node_modules/babel-plugin-transform-object-assign/lib/index.js\"],\"cacheDirectory\":true}!./src/pages/examples/i18n.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDripForm = __webpack_require__("../src/index.js");
	
	var _reactDripFormComponents = __webpack_require__("./node_modules/react-drip-form-components/lib/index.js");
	
	__webpack_require__("../node_modules/drip-form-validator/lib/locale/ja.js");
	
	var _components = __webpack_require__("./src/components/index.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable no-alert */
	/* eslint-disable import/extensions */
	/* eslint-disable import/no-unresolved */
	/* eslint-disable import/no-extraneous-dependencies */
	
	
	var I18nForm = (0, _reactDripForm.dripForm)({
	  validations: {
	    email: {
	      required: true,
	      email: true
	    },
	    message: {
	      required: true
	    }
	  }
	})(function (_ref) {
	  var handlers = _ref.handlers,
	      _ref$meta = _ref.meta,
	      invalid = _ref$meta.invalid,
	      pristine = _ref$meta.pristine;
	  return _react2.default.createElement(
	    'form',
	    { onSubmit: handlers.onSubmit },
	    _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        'label',
	        { htmlFor: 'email' },
	        '\u9001\u4FE1\u5148'
	      ),
	      _react2.default.createElement(_reactDripFormComponents.Input, {
	        id: 'email',
	        type: 'email',
	        name: 'email',
	        label: '\u9001\u4FE1\u5148'
	      })
	    ),
	    _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        'label',
	        { htmlFor: 'message' },
	        '\u30E1\u30C3\u30BB\u30FC\u30B8'
	      ),
	      _react2.default.createElement(_reactDripFormComponents.Textarea, {
	        id: 'message',
	        name: 'message',
	        label: '\u30E1\u30C3\u30BB\u30FC\u30B8'
	      })
	    ),
	    _react2.default.createElement(
	      _components.Button,
	      {
	        primary: true,
	        onClick: handlers.onSubmit,
	        disabled: invalid || pristine
	      },
	      '\u9001\u4FE1'
	    )
	  );
	});
	
	var BasicFormExample = function (_Component) {
	  _inherits(BasicFormExample, _Component);
	
	  function BasicFormExample() {
	    var _ref2;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, BasicFormExample);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref2 = BasicFormExample.__proto__ || Object.getPrototypeOf(BasicFormExample)).call.apply(_ref2, [this].concat(args))), _this), _this.state = {
	      values: {}
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(BasicFormExample, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      _reactDripForm.Validator.setLocale('ja');
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      _reactDripForm.Validator.setLocale('en');
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var location = this.props.location;
	      var values = this.state.values;
	
	
	      return _react2.default.createElement(
	        _components.Layout,
	        {
	          title: 'i18n',
	          location: location
	        },
	        _react2.default.createElement(
	          'p',
	          null,
	          _react2.default.createElement(
	            'code',
	            null,
	            'react-drip-form'
	          ),
	          ' supports to the error message i18n.',
	          _react2.default.createElement('br', null),
	          'You can deal with just one line using ',
	          _react2.default.createElement(
	            'code',
	            null,
	            'setLocale()'
	          ),
	          ' of ',
	          _react2.default.createElement(
	            'a',
	            { href: 'https://github.com/tsuyoshiwada/drip-form-validator' },
	            'drip-form-validator'
	          ),
	          '.',
	          _react2.default.createElement('br', null),
	          'For locales that do not exist in ',
	          _react2.default.createElement(
	            'code',
	            null,
	            'drip-form-validator'
	          ),
	          ', you can also define them with ',
	          _react2.default.createElement(
	            'code',
	            null,
	            'defineLocale()'
	          ),
	          '.'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'Labels and other components are not supported. I think ',
	          _react2.default.createElement(
	            'a',
	            { href: 'https://github.com/yahoo/react-intl' },
	            'yahoo/react-intl'
	          ),
	          ' is useful!'
	        ),
	        _react2.default.createElement('hr', null),
	        _react2.default.createElement(
	          'h3',
	          null,
	          'Example:'
	        ),
	        _react2.default.createElement(I18nForm, {
	          onChange: function onChange(v) {
	            return _this2.setState({ values: v });
	          },
	          onValidSubmit: function onValidSubmit(v) {
	            alert('See console');
	            console.log(v);
	          }
	        }),
	        _react2.default.createElement('hr', null),
	        _react2.default.createElement(
	          'h3',
	          null,
	          'Values:'
	        ),
	        _react2.default.createElement(
	          _components.Code,
	          { language: 'javascript' },
	          JSON.stringify(values, null, 2)
	        ),
	        _react2.default.createElement('hr', null),
	        _react2.default.createElement(
	          'h3',
	          null,
	          'Sample Code:'
	        ),
	        _react2.default.createElement(
	          _components.Code,
	          { language: 'javascript' },
	          'import React from \'react\';\nimport { dripForm, Validator } from \'react-drip-form\';\nimport { Input, Textarea } from \'react-drip-form-components\';\nimport \'drip-form-validator/lib/locale/ja\';\n\nValidator.setLocale(\'ja\')\n\nconst I18nForm = dripForm({\n  validations: {\n    email: {\n      required: true,\n      email: true,\n    },\n    message: {\n      required: true,\n    },\n  },\n})(({\n  handlers,\n  meta: { invalid, pristine },\n}) => (\n  <form onSubmit={handlers.onSubmit}>\n    <div>\n      <label htmlFor="email">\u9001\u4FE1\u5148</label>\n      <Input\n        id="email"\n        type="email"\n        name="email"\n        label="\u9001\u4FE1\u5148"\n      />\n    </div>\n\n    <div>\n      <label htmlFor="message">\u30E1\u30C3\u30BB\u30FC\u30B8</label>\n      <Textarea\n        id="message"\n        name="message"\n        label="\u30E1\u30C3\u30BB\u30FC\u30B8"\n      />\n    </div>\n\n    <Button\n      primary\n      onClick={handlers.onSubmit}\n      disabled={invalid || pristine}\n    >\n      \u9001\u4FE1\n    </Button>\n  </form>\n));\n'
	        )
	      );
	    }
	  }]);
	
	  return BasicFormExample;
	}(_react.Component);
	
	exports.default = BasicFormExample;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// page-component---src-pages-examples-i-18-n-js-03bb6f038cfbe2bf91d1.js